import { useState, useRef, useEffect } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext'
import Data from "../data/Data";
import Header from './Header';

function ChangePassword() {
    const [oldPassword, setOldPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [newPasswordAgain, setNewPasswordAgain] = useState('');
    const [validated, setValidated] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const formRef = useRef();
    const oldPasswordInputRef = useRef();
    const newPasswordInputRef = useRef();
    const newPasswordAgainInputRef = useRef();
    const { isLoggedIn } = useAuth();
    const navigate = useNavigate();

    const location = useLocation();

    useEffect(() => {
        const request = new URLSearchParams(location.search).get('request');
        if (request === null && isLoggedIn === false) {
            navigate('/login');
        }
    }, [isLoggedIn, location, navigate])

    const handleInputChange = (e, ref) => {
        ref.current.setCustomValidity('');
        if (e.target.name === 'oldPassword') {
            setOldPassword(e.target.value);
        }
        if (e.target.name === 'newPassword') {
            if (newPasswordAgain && e.target.value !== newPasswordAgain) {
                newPasswordAgainInputRef.current.setCustomValidity('Passwords do not match');
            } else {
                newPasswordAgainInputRef.current.setCustomValidity('');
            }
            setNewPassword(e.target.value);
        } else if (e.target.name === 'newPasswordAgain') {
            if (e.target.value !== newPassword) {
                newPasswordAgainInputRef.current.setCustomValidity('Passwords do not match');
            } else {
                newPasswordAgainInputRef.current.setCustomValidity('');
            }
            setNewPasswordAgain(e.target.value);
        }

        setErrorMessage('');
    };

    const handleChangePassword = async (e) => {
        e.preventDefault();
        console.log(newPasswordInputRef.current.validationMessage);
        console.log(oldPassword);

        if (formRef.current.checkValidity() === false) {
            e.stopPropagation();
        } else {
            const request = new URLSearchParams(location.search).get('request');
            var response = isLoggedIn ? 
            await Data.fetchChangePassword(oldPassword, newPassword, newPasswordAgain) : 
            await Data.fetchForgotChangePassword(request, newPassword, newPasswordAgain);

            if (response) {
                // TODO: implement here if old password was invalid

                if (response === 'INVALID_PASSWORD') {
                    setErrorMessage('Password is invalid. It must contain at least one lowercase letter, one uppercase letter, and one digit.');
                    newPasswordInputRef.current.setCustomValidity('Password is invalid. It must contain at least one lowercase letter, one uppercase letter, and one digit.');
                }
                else if (response === 'PASSWORD_MISMATCH') {
                    setErrorMessage('Passwords do not match');
                    newPasswordInputRef.current.setCustomValidity('Passwords do not match');
                }
                else {
                    setErrorMessage('Something went wrong');
                }
            } else {
                window.location.href = isLoggedIn ? '/user' : '/login';
            }
        }
        setOldPassword('');
        setNewPassword('');
        setNewPasswordAgain('');
        setValidated(true);
    }

    return (
        <div>
            <Header whiteLogo authButton={isLoggedIn} />
            <div className="Login container-fluid d-flex justify-content-center align-items-center">
                <div className="col-12 col-lg-6 box">
                    <h1 className="mb-4">Create new password</h1>
                    <form ref={formRef} className={`needs-validation ${validated ? 'was-validated' : ''}`} noValidate onSubmit={handleChangePassword}>
                        {errorMessage && !errorMessage.includes('Password') &&
                            <div className="alert alert-danger alert-dismissible fade show" role="alert">
                                {errorMessage}
                                <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close" onClick={() => setErrorMessage('')}></button>
                            </div>
                        }
                        {isLoggedIn && (
                            <div className="mb-5">
                                <label htmlFor="inputOldPassword" className="form-label">Old Password</label>
                                <input ref={oldPasswordInputRef} required type="password" className="form-control" id="inputOldPassword" name="oldPassword" value={oldPassword} onChange={e => handleInputChange(e, oldPasswordInputRef)} />
                                <div className="invalid-feedback">
                                    {oldPasswordInputRef.current && oldPasswordInputRef.current.validationMessage !== 'Something went wrong' ? (oldPasswordInputRef.current.validationMessage.includes('Password') ? oldPasswordInputRef.current.validationMessage : 'Password is required') : ''}
                                </div>
                            </div>
                        )}
                        <div className="mb-3">
                            <label htmlFor="inputNewPassword" className="form-label">New Password</label>
                            <input ref={newPasswordInputRef} required type="password" className="form-control" id="inputNewPassword" name="newPassword" value={newPassword} onChange={e => handleInputChange(e, newPasswordInputRef)} />
                            <div className="invalid-feedback">
                                {newPasswordInputRef.current && newPasswordInputRef.current.validationMessage !== 'Something went wrong' ? (newPasswordInputRef.current.validationMessage.includes('Password') ? newPasswordInputRef.current.validationMessage : 'Password is required') : ''}
                            </div>
                        </div>
                        <div className="mb-3">
                            <label htmlFor="inputNewPasswordAgain" className="form-label">Confirm New Password</label>
                            <input ref={newPasswordAgainInputRef} required type="password" className="form-control" id="inputNewPasswordAgain" name="newPasswordAgain" value={newPasswordAgain} onChange={e => handleInputChange(e, newPasswordAgainInputRef)} />
                            <div className="invalid-feedback">
                                {newPasswordAgainInputRef.current && newPasswordAgainInputRef.current.validationMessage !== 'Something went wrong' ? (newPasswordAgainInputRef.current.validationMessage.includes('Password') ? newPasswordAgainInputRef.current.validationMessage : 'Please confirm your password') : ''}
                            </div>
                        </div>
                        <div className="row d-flex align-items-center">
                            <div className="col-12 text-end">
                                {isLoggedIn && <button className="btn btn-outline-danger me-3" onClick={() => navigate('/user-settings')}>Cancel</button>}
                                <button className="btn btn-primary">Submit</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}
export default ChangePassword;